
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

export type AnonymityOptionProps = {
  form: UseFormReturn<any>;
  isAnonymous: boolean;
  setIsAnonymous: (value: boolean) => void;
  isDisabled?: boolean;
};

export const AnonymityOption: React.FC<AnonymityOptionProps> = ({ 
  form, 
  isAnonymous,
  setIsAnonymous,
  isDisabled = false 
}) => {
  return (
    <div className="flex items-center space-x-2 mb-4 mt-6">
      <Switch
        id="anonymity"
        checked={isAnonymous}
        disabled={isDisabled}
        onCheckedChange={setIsAnonymous}
      />
      <Label htmlFor="anonymity" className="cursor-pointer">
        Envoyer mon feedback de façon anonyme
      </Label>
    </div>
  );
};
